import { render, staticRenderFns } from "./AppInstagramPost.vue?vue&type=template&id=d96bfd40"
import script from "./AppInstagramPost.vue?vue&type=script&lang=js"
export * from "./AppInstagramPost.vue?vue&type=script&lang=js"
import style0 from "./AppInstagramPost.vue?vue&type=style&index=0&id=d96bfd40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports